export default function accordions() {
    //think this is unused in LUIS, because most or all of its acordions come from wt-lu-blocks plugin, but unsure, so leaving for now
    if ($('.accordion_title').length > 0) {
        $('.accordion').attr('role', 'presentation');
        $('.accordion_title').attr('role', 'heading');
        $('.accordion_title').attr({ tabindex: 0, 'aria-expanded': false });
        $('.accordion_content').attr({ role: 'region', 'aria-hidden': true });
        $('.accordion_item').each(function(index) {
            $(this)
                .find($('.accordion_title'))
                .attr({
                    'aria-controls': 'content-' + index,
                    id: 'accordion-' + index
                });
            $(this)
                .find($('.accordion_content'))
                .attr({
                    'aria-labelledby': 'accordion-' + index,
                    id: 'content-' + index
                });
        });
        $('.accordion_title').on('click', function(e) {
            if (
                $(this)
                    .closest('.accordion_item')
                    .hasClass('active')
            ) {
                $(this)
                    .closest('.accordion')
                    .find('.accordion_item')
                    .removeClass('active');
                $(this).attr('aria-expanded', false);
                $(this)
                    .siblings('.accordion_content')
                    .attr('aria-hidden', true);
                $(this)
                    .closest('.accordion_item')
                    .find('.accordion_content')
                    .stop(true, true)
                    .slideUp(200);
            } else {
                $(this)
                    .closest('.accordion')
                    .find('.accordion_item.active .accordion_content')
                    .stop(true, true)
                    .slideUp();
                $(this)
                    .closest('.accordion')
                    .find('.accordion_item.active')
                    .removeClass('active');
                $(this)
                    .closest('.accordion_item')
                    .addClass('active');
                $(this)
                    .closest('.accordion')
                    .find('.accordion_title[aria-expanded="true"]')
                    .attr('aria-expanded', false);
                $(this)
                    .closest('.accordion')
                    .find('.accordion_content[aria-hidden="false"]')
                    .attr('aria-hidden', true);
                $(this).attr('aria-expanded', true);
                $(this)
                    .siblings('.accordion_content')
                    .attr('aria-hidden', false);
                $(this)
                    .closest('.accordion_item')
                    .find('.accordion_content')
                    .stop(true, true)
                    .slideDown(200);
            }
        });
    }
}